import React, { useEffect,Suspense, lazy } from 'react';
import { BrowserRouter as Router, Routes, Route, Navigate } from 'react-router-dom';
import { withStyles } from '@mui/styles';
import Hotjar from '@hotjar/browser';
import { CircularProgress, Zoom, Tooltip } from '@mui/material';
import ClearOutlined from '@mui/icons-material/ClearOutlined';
import firebase, { db } from './firebase'; // firebase
import { connect } from 'react-redux';
import { getPartnerPlanId, getCompanyFonts, close_adminDemo, getPlans, setCompanyDomain, getPartnerPlanExpiry, closeUpgradeDialog } from '../store/action';
import UpgradeDialog from '../components/UpgradeDialog';
import { ReAuthDialog } from '../components/partner-comp';
import { Session } from '../components';
import FavIcon from 'src/assets/images/fav.png';
import CustomMetaData from 'src/hooks/CustomMetaData';
import CourseContent from 'src/screens/Parents/screens/Course/CourseContent';
import ElevenLabsWidget from './ElevenLabsWidget' // ai agent widget

import 'src/assets/stylesheet/navigation.css';

import LazyLoader from 'src/LazyLoader';
// plan upgrade dialog
const SubcriptionUpgradeDialog = lazy(() => import('src/components/white-label-component/company-booking/SubcriptionUpgradeDialog.jsx'));
const AddCompany = lazy(() => import('../screens/AddCompany'));
const EditCompany = lazy(() => import('../screens/EditCompany'));
const EditActivity = lazy(() => import('../screens/EditActivity'));
const Review = lazy(() => import('../screens/Review'));
const EditSchool = lazy(() => import('../screens/EditSchool'));
const GroupList = lazy(() => import('../screens/GroupList'));
const Group = lazy(() => import('../screens/Group'));
const EditGroup = lazy(() => import('../screens/EditGroup'));
const Dashboard = lazy(() => import('../screens/Dashboard'));
const ForgetPass = lazy(() => import('../screens/ForgetPass'));
const AddActivity = lazy(() => import('../screens/AddActivity'));
const Page404 = lazy(() => import('../screens/Page404'));

const Service = lazy(() => import('src/screens/Partners/Service/Service')); // Service new design
const OnlineSessionWizard = lazy(() => import('src/screens/Partners/Service/OnlineSessionWizard')); // Service online session wizard
const CreateCourse = lazy(() => import('src/screens/Partners/Courses/CreateCourse/CreateCourse')); // Service new design
const Courses = lazy(() => import('src/screens/Partners/Courses/Courses')); // Service new design

const Reservations = lazy(() => import('src/screens/Reservations/Reservations'));
const WithdrawalRequests = lazy(() => import('src/screens/Admins/WithdrawalRequests'));
const ReportedIssues = lazy(() => import('src/screens/Admins/ReportedIssues'));

// parent Components
const ParentLogin = lazy(() => import('../screens/Parents/screens/Login'));
const NotFound = lazy(() => import('../screens/Parents/screens/NotFound/NotFound'));
const PartnerWebsiteIframe= lazy(() => import('../screens/Parents/screens/PartnerWebsiteIframe'));
const ParentResetPassword = lazy(() => import('../screens/Parents/screens/ResetPasswordWrapper'));
const MyAccount = lazy(() => import('src/screens/Parents/screens/MyAccount'));
const BookingContent = lazy(() => import('src/screens/Parents/screens/BookingContent/BookingContent'));
const LiveSessions = lazy(() => import('src/screens/Parents/screens/AllSessions'));
const Announcements = lazy(() => import('src/screens/Parents/screens/Announcements'));
const Billings = lazy(() => import('src/screens/Parents/screens/Billings'));
const Certificates = lazy(() => import('src/screens/Parents/screens/Certificates'));
const Appointments = lazy(() => import('src/screens/Parents/screens/Appointment/Appointments'));
const MyBooking = lazy(() => import('src/screens/Parents/screens/MyBooking'));
const MyCourses = lazy(() => import('src/screens/Parents/screens/Course/MyCourses'));
const QuizPage = lazy(() => import('src/screens/Parents/screens/Course/components/quiz/QuizRender'));
// const CourseContent = lazy(() => import('src/screens/Parents/screens/Course/CourseContent'));
const RenewBooking = lazy(() => import('src/screens/Parents/screens/RenewBooking'));
const RenewLogin = lazy(() => import('src/screens/Parents/screens/RenewLogin'));
const LinkBooking = lazy(() => import('src/screens/Parents/screens/LinkBooking'));
const ScheduleBooking = lazy(() => import('src/screens/Parents/screens/ScheduleBooking'));
const Booking = lazy(() => import('src/screens/Parents/screens/Booking'));
// const Booking = lazy(() => import('src/screens/Parents/screens/BookingTest'));
const OnlineSession = lazy(() => import('src/screens/Parents/screens/OnlineSession'));
const CertificateVerification = lazy(() => import('../screens/Parents/screens/CertificateVerification'));

// Partners components
const PartnerSideMenuLayout = lazy(()=> import('src/components/PartnerLayout/PartnerSideMenuLayout'))
const GenerateCourse = lazy(()=> import('../screens/Partners/Courses/CourseAI/GenerateCourse'));
const PartnerLogin = lazy(() => import('../screens/Partners/PartnerLogin'));
const Activities = lazy(() => import('../screens/Partners/Activities'));
const Groupings = lazy(() => import('../screens/Partners/Groupings/Groupings'));
const Message = lazy(() => import('../screens/Partners/Message'));
const Message2 = lazy(() => import('../screens/Partners/Message2'));
const Setting = lazy(() => import('../screens/Partners/Setting'));
const ChatRoom = lazy(() => import('../screens/Partners/ChatRoom'));
const Analytic = lazy(() => import('../screens/Partners/Analytic'));
const EditProfile = lazy(() => import('../screens/Partners/EditProfile'));
const AddSchool = lazy(() => import('../screens/Partners/AddSchool'));
const Modal = lazy(() => import('../screens/Partners/Modal'));
const Voucher = lazy(() => import('../screens/Partners/Voucher'));
const UserManagment = lazy(() => import('../screens/Partners/UserManagment'));
const SendEmail = lazy(() => import('../screens/Partners/SendEmail'));
const Wallet = lazy(() => import('../screens/Partners/Wallet'));
const NewReservation = lazy(() => import('../screens/Partners/NewReservation'));
const CurrentReservation = lazy(() => import('../screens/Partners/CurrentReservation'));
const MobileBookings = lazy(() => import('../screens/Partners/MobileBookings'));
const GroupReservations = lazy(() => import('../screens/Partners/GroupReservations'));
const ReservationsReport = lazy(() => import('../screens/Partners/ReservationsReport'));
const ReservationScanner = lazy(() => import('../screens/Partners/ReservationScanner'));
const NewSchoolReservation = lazy(() => import('../screens/Partners/NewSchoolReservation'));
const AdmitSchoolReservation = lazy(() => import('../screens/Partners/AdmitSchoolReservation'));
const WaitingSchoolReservation = lazy(() => import('../screens/Partners/WaitingSchoolReservation'));
const ReservationSubscription = lazy(()=> import('../screens/Partners/ReservationSubscription/ReservationSubscription'));
const SchoolOption = lazy(() => import('../screens/Partners/SchoolOption'));
const SchoolSettings = lazy(() => import('../screens/Partners/SchoolSettings'));
const CompanySetting = lazy(() => import('../screens/Partners/Setting/CompanySetting'));
const MainSetting = lazy(() => import('../screens/Partners/Setting/Settings'));
const WebsiteSetting = lazy(() => import('../screens/Partners/Website/screen/WebsiteSetting'));
const CreateCategory = lazy(() => import('../screens/Partners/CreateCategory'));
const PartnerPaymentLink = lazy(()=> import('../screens/Partners/PaymentLinks'));
const PartnerAllLiveSessions = lazy(()=> import('../screens/Partners/LiveSession/AllLiveSessions'));
const RenewPaytabsSubscription = lazy(()=> import('../screens/Partners/Paytabs/RenewSubscription'));
const AppointmentList = lazy(()=> import('../screens/Partners/SchedulesBooking/AppointmentList'));
const IntegrateApplications = lazy(()=> import('../screens/Partners/ApplicationIntegration/Applications'));
const Customers = lazy(()=> import('../screens/Partners/Customers/Customer'));
const CourseContentPreview = lazy(()=> import('src/screens/Partners/Courses/CourseContentPreview'));

// Admins components
const AdminLogin = lazy(() => import('../screens/Admins/AdminLogin'));
const CompanyRecord = lazy(() => import('../screens/Admins/CompanyRecord/CompanyRecord'));
const DesignerCompanyRecord = lazy(() => import('../screens/Admins/CompanyRecord/DesignerCompanyRecord'));
const NewCompanyRecord = lazy(() => import('../screens/Admins/NewCompanyRecord'));
const ActivityRecord = lazy(() => import('../screens/Admins/ActivityRecord'));
const Featured = lazy(() => import('../screens/Admins/Featured'));
const SchoolRecord = lazy(() => import('../screens/Admins/SchoolRecord'));
const TrackRecord = lazy(() => import('../screens/Admins/TrackRecord'));
const RefundRecord = lazy(() => import('../screens/Admins/RefundRecord'));
const NewActivityRecord = lazy(() => import('../screens/Admins/NewActivityRecord'));
const ManageTags = lazy(() => import('../screens/Admins/ManageTags'));
const Tags = lazy(() => import('../screens/Admins/Tags'));
const ReservationRecord = lazy(() => import('../screens/Admins/ReservationRecord'));
const IssueResRecord = lazy(() => import('../screens/Admins/IssueResRecord'));
const TopSelected = lazy(() => import('../screens/Admins/TopSelected'));
const ManageHome = lazy(() => import('../screens/Admins/ManageHome'));
const HomePageVisual = lazy(() => import('../screens/Admins/HomePageVisual'));
const UpdateResDate = lazy(() => import('../screens/Admins/UpdateResDate'));
const Refund = lazy(() => import('../screens/Admins/Refund'));
const CurrencyConversion = lazy(() => import('../screens/Admins/CurrencyConversion'));
const UpdateWallet = lazy(() => import('../screens/Admins/UpdateWallet'));
const WalletRecord = lazy(() => import('../screens/Admins/WalletRecord'));
const SelynkPlans = lazy(() => import('../screens/Admins/SelynkPlans'));
const CategoryManagement = lazy(() => import('../screens/Admins/CategoryManagement'));
const AdminEditSchool = lazy(() => import('../screens/Admins/EditSchool'));

// Super-Admin components
const AddAdmin = lazy(() => import('../screens/Super_Admin/AddAdmin'));
const AdminTop = lazy(() => import('../screens/Super_Admin/AdminTop'));
const FeatureManage = lazy(() => import('../screens/Super_Admin/FeatureManage'));

//school admission
const SchoolAdmission = lazy(() => import('../screens/WhiteLabels/school-admission/SchoolAdmission'));
const SchoolAdmission2 = lazy(() => import('../screens/WhiteLabels/school-admission/SchoolAdmission2'));

// mobile message screen
const ChatRoom2 = lazy(() => import('../components/message-comp/mobile-comp/ChatRoom'));

const ParentReview = lazy(() => import('../screens/Parents/ParentReview'));
const ProviderDeletion = lazy(() => import('../screens/Parents/ProviderDeletion'));

const CompanyPage = lazy(() => import('../screens/WhiteLabels/CompanyPage'));
const ActivityPage = lazy(() => import('../screens/WhiteLabels/ActivityPage'));
const ProductPage = lazy(() => import('../screens/WhiteLabels/ProductPage'));
const CategoryPage = lazy(() => import('../screens/WhiteLabels/CategoryPage'));

const GetStarted = lazy(() => import('../screens/Partners/GetStarted/GetStarted'));
const DemoCompanyPage = lazy(() => import('../screens/Partners/GetStarted/DemoCompanyPage'));
const Welcome = lazy(() => import('../screens/WhiteLabels/company-booking/Welcome'));

// paymenst
const FatoorahPaymentStatus = lazy(() => import('../components/payment-comp/FatoorahPaymentStatus'));

// Payment status page for stripe add payment method > company-setting -> billing tab
const PaymentStatus = lazy(() => import('../components/company-setting/PaymentStatus'));
const PaytabSuccess = lazy(() => import('../components/payment-comp/PaytabSuccess'));
const TapPaymentStatus = lazy(() => import('../components/payment-comp/Tap/TapPaymentStatus'));
const IyzicoSuccess = lazy(() => import('../components/payment-comp/Iyzico/IyzicoSuccess'));
const PayPalStatus = lazy(() => import('../components/payment-comp/PaypalStatus'));
// affilate form
const AffiliateForm = lazy(() => import('../screens/AffiliateForm'));

const siteId = process.env.REACT_APP_GETSTARTED_HOTJAR;
const hotjarVersion = 6;


const LightTooltip = withStyles((theme) => ({
  tooltip: {
    backgroundColor: '#263238',
    color: '#fff',
    fontSize: 11,
    zIndex: 100000000000000,
    marginLeft:'40px'
  },
  arrow: {
    color: '#263238',
  },

}))(Tooltip);

const ColorCircularProgress = withStyles({
  root: {
    color: '#0F467A',
    width: '40px',
    height: '40px',
    position: 'absolute',
    top: '50%',
    left: '50%',
  },
})(CircularProgress);

function Navigator(props) {
  const isMounted = React.useRef(null);
  const { company, ugardeDlg, user, adminDemo } = props;
  // const classes = useStyles();
  const [loading, setLoading] = React.useState(true);
  const [companyId, setCompanyId] = React.useState('');
  const [companyData,setCompanyData] = React.useState({});
  const partner_companyId = company && company.id;
  const isParent = company && company.isParentData;
  const evsCompanyId = '-MClSQhBtMHtE5BebSGC';

  useEffect(() => {
    async function _checkHostname() {
      isMounted.current = true;
      const host = window.location.host;
      const pathname = window.location.pathname;
      if (host === 'my.selynk.com' || host === 'localhost:3000' || host === 'selynk-uk.web.app' || host === '786f-203-171-102-171.ngrok-free.app' || host === 'selynk-uk--form-action-partner-28c0h8s7.web.app' || host === 'selynk-uk--form-action-website-1m0kq5uz.web.app' || host === 'selynk-uk.uc.r.appspot.com' || host === '' || (pathname != '/home' && pathname.length > 1)) {
        if (isMounted.current) {
          setLoading(false);
          props.company_domain(false);
        } 
      } else if (host !== 'my.selynk.com' || host !== 'selynk-uk.web.app' || host !== 'selynk-uk.uc.r.appspot.com' || host !== 'selynk-uk--form-action-partner-28c0h8s7.web.app' || host !== 'selynk-uk--form-action-website-1m0kq5uz.web.app') {
        const company = await (
          await db
            .ref(`Companies`)
            .orderByChild('domain')
            .equalTo(host)
            .once('value')
        ).val();
        if (company) {
          const companyId = Object.keys(company)[0];
          const companyData = Object.values(company)[0];
          if (isMounted.current) {
            setCompanyId(companyId);
            props.company_domain(true);
            setLoading(false);
            setCompanyData(companyData);
            setTimeout(()=> window.prerenderReady = true,3000); 
          }
        } else {
          if (isMounted.current) {
            props.company_domain(false);
            setLoading(false);
          }
        }
      } else {
        if (isMounted.current) {
          props.company_domain(false);
          setLoading(false);
        }
      }
    }

    async function _getPlan() {
      // Get plans
      isMounted.current = true;
      if (isMounted.current) props.set_plan();
    };

    async function initiateHotjar() {
      isMounted.current = true;
      const host = window.location.host;
      if(['localhost:3000', 'user.selynk.com'].includes(host) && isMounted.current) {
        Hotjar.init(siteId, hotjarVersion);
        if(window.ttq) window.ttq.page();
        if(window.snaptr) window.snaptr('track', 'PAGE_VIEW'); 
      };
    }

    async function initClarityScript() {
      isMounted.current = true;
      const host = window.location.host;
      if(['localhost:3000', 'user.selynk.com'].includes(host) && isMounted.current) {
        const script = document.createElement("script");
        script.type = "text/javascript";
        script.async = true;
    
        // Add the Clarity script content
        script.innerHTML = `
          (function(c,l,a,r,i,t,y){
              c[a]=c[a]||function(){(c[a].q=c[a].q||[]).push(arguments)};
              t=l.createElement(r);t.async=1;t.src="https://www.clarity.ms/tag/"+i;
              y=l.getElementsByTagName(r)[0];y.parentNode.insertBefore(t,y);
          })(window, document, "clarity", "script", "pzmljglg65");
        `;
    
        // Append the script to the document head or body
        document.head.appendChild(script);
      }
    };

    _checkHostname();
    _getPlan();
    initiateHotjar();
    initClarityScript();
    return () => {
      isMounted.current = false;
    };
  }, []);

  useEffect(() => {
    if (company) {
      props.set_planId(company.id);
      props.get_company_fonts(company?.id);
      // props.setUpgradeDialog(company.id);
    }
  }, [company && company.id]);

  const closeAdminDemoView = () => {
    props._close_adminDemo();
    setLoading(true);
    setTimeout(()=> window.close(),3000);
  };

  const subDomain = window.location.host.split(".")[0];

  return (
    <>
    { !props.adminDemo ?
    null
    :
    <div className={!props.adminDemo ? 'adminVHidden' : 'adminViewBtn'}>
      <LightTooltip title="Click to close demo view" placement="right" arrow TransitionComponent={Zoom}>
        <ClearOutlined className={'viewIcon'} onClick={closeAdminDemoView} />
      </LightTooltip>
    </div>
    }
      {
        companyId || subDomain !== 'user' || subDomain !== 'localhost:3000' || subDomain !== 'selynk-uk--form-action-partner-28c0h8s7' || subDomain !== 'ef9d-149-54-39-10' ?
          null
          :
          <CustomMetaData
            {...{
              title: "Selynk",
              image: FavIcon,
              description: 'Selynk App'
            }}
          />
      }

      {!loading ? (
        <Suspense fallback={<LazyLoader />}>
        <Router>
          {subDomain === 'user' || subDomain === 'localhost:3000' || subDomain === 'selynk-uk--form-action-partner-28c0h8s7' || subDomain === 'ef9d-149-54-39-10' || subDomain === 'selynk-uk--partner-website-fix-dj7jmzcn' ?
            <>
            {/* <Session /> */}
            <PartnerRoutes />

            {(user && user?.roleType !== 'instructor') && !adminDemo && ugardeDlg && (user && user?.id) ?
            <SubcriptionUpgradeDialog 
                {...{
                  closeUpgradeDialog: ()=> props._closeUpgradeDialog(false),
                  showUpgrade: ugardeDlg,
                  company,
                  loadTiktokSnapEvent:false
                }}
            />
            : null}
            </>
          :
            <ParentRoutes companyId={companyId} />
          }

          <UpgradeDialog />
          {(!isParent && partner_companyId === evsCompanyId)  ? <ReAuthDialog /> : null }
        </Router>
        </Suspense>
      ) : (
        <ColorCircularProgress />
      )}
    </>
  );
};


const ParentRoutes = ({companyId}) => {
  const host = window.location.host;
  return (
    (<Routes>
      {/* Root route */}
      {(['localhost:3002','localhost:3001', 'my.selynk.com', 'selynk-uk--form-action-website-1m0kq5uz.web.app'].includes(host) ? (
        // Route for dynamic access
        (<Route path="/:id/*" element={<CompanyPage />} />)
      ) : (
        // Route for custom domain access
        (<Route path="/*" element={<CompanyPage companyId={companyId} />} />)
      ))}
      {/* Redirect /home to root */}
      <Route path="/home" element={<Navigate to="/" replace />} />
      {/* Links for parents */}
      <Route path="/quiz" element={<QuizPage />} />
      <Route path="/login/:companyId?" element={<ParentLogin />} />
      <Route path="/administration" element={<PartnerWebsiteIframe />} />
      <Route path="/reset-password/:companyId?" element={<ParentResetPassword />} />
      <Route path="/my-booking" element={<MyBooking />} />
      <Route path="/not-found" element={<NotFound />} />
      <Route path="/:urlName?/my-course/:id" element={<CourseContent />} />
      <Route path="/announcements" element={<Announcements />} />
      <Route path="/billing" element={<Billings />} />
      <Route path="/certificates" element={<Certificates />} />
      <Route path="/appointments" element={<Appointments />} />
      <Route path="/my-account" element={<MyAccount />} />
      <Route path="/:urlName?/content/:id" element={<BookingContent />} />
      <Route path="/live-session" element={<LiveSessions />} />
      <Route path="/session/:sessionId" element={<OnlineSession />} />
      <Route path="/renew-booking/:companyId?" element={<RenewBooking />} />
      <Route path="/renew/:companyId?/:reservationId?" element={<RenewLogin />} />
      <Route path="/school-admission/:id" element={<SchoolAdmission />} />
      <Route path="/school-admission2/:id" element={<SchoolAdmission2 />} />
      <Route path="/parent-review/:id" element={<ParentReview />} />
      <Route path="/provider-deletion/:id" element={<ProviderDeletion />} />
      <Route path="/products/:id" element={<ProductPage />} />
      <Route path="/categories/:companyId/:categoryId" element={<CategoryPage />} />
      <Route path="/activity/:id" element={<ActivityPage />} />
      <Route path="/link/:id" element={<LinkBooking />} />
      <Route path="/schedule-booking/:id/:date/:parTzTimeslot/:userTzTimeslot/:parTz/:userTz" element={<ScheduleBooking />} />
      <Route path="/booking/:id/:gpId?" element={<Booking />} />
      <Route path="/payment_status/:type" element={<FatoorahPaymentStatus />} />
      <Route path="/pay-status/:pCode?/:pMsg?/:redirect?" element={<PaytabSuccess />} />
      <Route path="/payment-status/:companyId" element={<TapPaymentStatus />} />
      <Route path="/pay_status/:pCode?" element={<IyzicoSuccess />} />
      <Route path="/404" element={<Page404 />} />
      <Route path="/dashboard" element={<Dashboard />} />
      <Route path="/verify-certificate/:certificateId" element={<CertificateVerification />} />
      {/* Dynamic routes */}
      <Route path="/:id/company" element={<CompanyPage />} />
      <Route path="/company/:id" element={<CompanyPage />} />
      <Route path="/demoCompany/:id" element={<DemoCompanyPage />} />
    </Routes>)
  );
}

const PartnerRoutes = () => {
  return(
    <>
    <CustomMetaData
      {...{
        title: "Selynk",
        image: FavIcon,
        description: 'Selynk App'
      }}
    />
    <ElevenLabsWidget />
    <Routes>
      {/* links only for partners */}
      <Route
        path="/"
        element={<PartnerLogin />}
      />
      <Route path="/quiz" element={<QuizPage quizId="-O78-_HWZwOGrtB8GSJk" />} />
      <Route path="/affilateForm" element={<AffiliateForm />} />
      {/* <Route
          path="/quiz/module1"2
          element={<QuizPage module={module1} />}c
      /> */}

      {/* side menu compoents start */}
      {/* <PartnerSideMenuLayout> */}
      <Route element={<PartnerSideMenuLayout />}>
        <Route path="/dashboard" element={<Dashboard />} />
        <Route path="/addschool/:id/:cc" element={<AddSchool />} />
        <Route path="/services" element={<Activities />} />
        <Route path="/welcome-partner" element={<Welcome/>} />
        <Route path="/appointments" element={<AppointmentList />} />
        <Route path="/customers" element={<Customers />} />
        <Route path="/my-course/:id" element={<CourseContentPreview />} />
        <Route path="/integrate_apps" element={<IntegrateApplications />} />
        <Route path="/message" element={<Message />} />
        <Route path="/mes2" element={<Message2 />} />
        <Route path="s/analytic" element={<Analytic />} />
        <Route path="/updateProfile" element={<EditProfile />} />
        <Route path="/voucher" element={<Voucher />} />
        <Route path="/user-management" element={<UserManagment />} />
        <Route path="/sendemail" element={<SendEmail />} />
        <Route path="/wallet" element={<Wallet />} />
        <Route path="/category" element={<CreateCategory />} />
        <Route path="/course-ai" element={<GenerateCourse />} />
        <Route
          path="/chat/:compId/:patId/:id"
          element={<ChatRoom />}
        />
        {/* reservations links */}
        <Route path="/reservation" element={<NewReservation />} />
        <Route path="/current-reservation" element={<CurrentReservation />} />
        <Route path="/bookings" element={<MobileBookings />} />
        <Route path="/reservations-report" element={<ReservationsReport />} />
        <Route path="/booking-subscriptions" element={<ReservationSubscription />} />
        <Route path="/create-paymentlink" element={<PartnerPaymentLink />} />
        <Route path="/online-sessions" element={<PartnerAllLiveSessions />} />
        <Route
          path="/scan-reservation"
          element={<ReservationScanner />}
        />
        <Route
          path="/group-reservation"
          element={<GroupReservations />}
        />
        <Route
          path="/reservations-report2"
          element={<Reservations />}
        />
        {/* school reservations links */}
        <Route
          path="/school-reservation/:id"
          element={<NewSchoolReservation />}
        />
        <Route
          path="/admit-reservation/:id"
          element={<AdmitSchoolReservation />}
        />
        <Route
          path="/waiting-reservation/:id"
          element={<WaitingSchoolReservation />}
        />
        <Route path="/option/:id" element={<SchoolOption />} />
        <Route
          path="/school-setting/:id"
          element={<SchoolSettings />}
        />
        <Route path="/company-setting" element={<CompanySetting />} />
        <Route path="/settings" element={<MainSetting />} />
        <Route path="/website" element={<WebsiteSetting />} />      
        {/* new service design routes */}
        <Route path="/service/:serviceId?" element={<Service />} />
        <Route path="/onlineSession" element={<OnlineSessionWizard />} />
        <Route path="/course/:courseId?" element={<CreateCourse />} />
        <Route path="/courses" element={<Courses />} />
        <Route path="/groupings" element={<Groupings />} />
        <Route path="/school/:id" element={<EditSchool />} />
      </Route>
      {/* </PartnerSideMenuLayout> */}
      {/* side menu components end */}

      {/* without side menu pages start */}
      {/* register new company route */}
      <Route
        path="/getstarted/:activeStep?/:service?"
        element={<GetStarted />}
      />
      {/* mobile message */}
      <Route path="/ch/:chatId" element={<ChatRoom2 />} />
      <Route path="/more" element={<Setting />} />
      <Route path="/addAc/:id/:cc" element={<Modal />} />
      {/* stripe */}
      <Route path="/setup-complete" element={<PaymentStatus />} />
      <Route
        path="/school-admission/:id"
        element={<SchoolAdmission />}
      />
      <Route
        path="/school-admission2/:id"
        element={<SchoolAdmission2 />}
      />
      <Route path="/parent-review/:id" element={<ParentReview />} />
      <Route path="/provider-deletion/:id" element={<ProviderDeletion />} />
      {/* paytabs renew subscription */}
      <Route path="/renew_subscription/:companyId/:transactionId" element={<RenewPaytabsSubscription />} />
      {/* Company booking list */} // todo
      <Route path="/:id/company" element={<CompanyPage />} />
      <Route path="/products/:id" element={<ProductPage />} />
      <Route path="/categories/:companyId/:categoryId" element={<CategoryPage />} />
      <Route path="/company/:id" element={<CompanyPage />} />
      <Route path="/demoCompany/:id" element={<DemoCompanyPage />} />
      {/* route for companyId -M830UnkGtfiYzbxMPkx because they advertise */}
      <Route path="/activity/:id" element={<ActivityPage />} />
      <Route path="/link/:id" element={<LinkBooking />} />
      <Route path="/booking/:id/:gpId?" element={<Booking />} />
      <Route // todo
        path="/payment_status/:type"
        element={<FatoorahPaymentStatus />}
      />
      <Route path="/paypal-status/:status?" element={<PayPalStatus />} />
      {/* links for admin and partners */}
      <Route path="/forgetpass" element={<ForgetPass />} />
      <Route path="/admin_dashboard" element={<Dashboard />} /> // todo
      <Route path="/addcomp" element={<AddCompany />} />
      <Route path="/addactivity/:id/:new?" element={<AddActivity />} />
      <Route path="/comp/:id" element={<EditCompany />} />
      <Route path="/acti/:id/:compId" element={<EditActivity />} />
      <Route path="/admin_school/:id" element={<AdminEditSchool />} />
      <Route path="/addgroup/:id" element={<Group />} />
      <Route path="/editgroup/:id" element={<EditGroup />} />
      <Route path="/review/:id" element={<Review />} />
      <Route path="/group/:id" element={<GroupList />} />
      {/* without side menu pages end */}

      {/* links for all admins */}
      <Route path="/admin" element={<AdminLogin />} />
      <Route path="/comp-info" element={<CompanyRecord />} />
      <Route path="/companies" element={<DesignerCompanyRecord />} />
      <Route path="/school-info" element={<SchoolRecord />} />
      <Route path="/new-comp-info" element={<NewCompanyRecord />} />
      <Route path="/acti-info/:companyId?" element={<ActivityRecord />} />
      <Route path="/sub-plan" element={<SelynkPlans />} />
      <Route path="/category-manage" element={<CategoryManagement />} />
      <Route
        path="/currency-conversion"
        element={<CurrencyConversion />}
      />
      <Route
        path="/new-acti-info"
        element={<NewActivityRecord />}
      />
      <Route path="/managetags" element={<ManageTags />} />
      <Route path="/tags/:id" element={<Tags />} />
      <Route path="/top/:cc" element={<TopSelected />} />
      <Route path="/feature/:cc" element={<Featured />} />
      <Route
        path="/reservation-rec"
        element={<ReservationRecord />}
      />
      <Route
        path="/issue-reservation"
        element={<IssueResRecord />}
      />
      <Route path="/db-track" element={<TrackRecord />} />
      <Route path="/refund-record" element={<RefundRecord />} />
      <Route path="/manage-home" element={<ManageHome />} />
      <Route path="/home/:cc" element={<HomePageVisual />} />
      <Route path="/update-date" element={<UpdateResDate />} />
      <Route path="/refund/:id" element={<Refund />} />
      <Route path="/update-wallet" element={<UpdateWallet />} />
      <Route path="/wallet-record" element={<WalletRecord />} />
      {/* links only for super-admin */}
      <Route path="/addadmin" element={<AddAdmin />} />
      <Route path="/top-manage" element={<AdminTop />} />
      <Route path="/feature-manage" element={<FeatureManage />} />
      <Route
        path="/withdrawal-requests"
        element={<WithdrawalRequests />}
      />
      <Route path="/reported-issues" element={<ReportedIssues />} />
      <Route element={<Page404 />} />
    </Routes>
    </>
  )
}

const mapStateToProps = (state) => {
  return {
    plans: state.plans,
    dialog: state.dialog,
    company: state.company,
    user : state.user,
    adminDemo: state.adminDemo,
    ugardeDlg: state.ugardeDlg
  };
};

const mapDispatchToProps = (dispatch) => {
  return {
    set_plan: () => dispatch(getPlans()),
    set_planId: (companyId) => dispatch(getPartnerPlanId(companyId)),
    get_company_fonts: companyId => dispatch(getCompanyFonts(companyId)),
    _close_adminDemo: () => dispatch(close_adminDemo()),
    company_domain: (event) => dispatch(setCompanyDomain(event)),
    setUpgradeDialog: (companyId) => dispatch(getPartnerPlanExpiry(companyId)),
    _closeUpgradeDialog: (event) => dispatch(closeUpgradeDialog(event))
  };
};

export default connect(mapStateToProps, mapDispatchToProps)(Navigator);